import React, { useContext, useEffect, useState } from "react";
import { Minus, Plus, Star } from "react-feather";
import { Col, Modal, Row } from "reactstrap";
import "./productpage.css";
//context
import { AppContext } from "../../contexts/AppContext";
import ZoomProduct from "../Zoom/ZoomProduct";
import ProductList from "../../config/productlist.json";

function ProductPage() {
  const {
    selectedProduct,
    handleAddToCart,
    toggleProductZoom,
    isOpenZoomProduct,
    setSelectedProduct,
    quickViewModal,
    windowSize,
  } = useContext(AppContext);
  const [imageIndex, setImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  console.log("windowSize: ", windowSize);

  useEffect(() => {
    if (!quickViewModal && window.location.href.includes("products")) {
      const productName = window.location.pathname
        .split("/")[2]
        ?.split("-")
        .join(" ");
      const product = ProductList.Products.filter(
        (item) => item.name.toLowerCase()?.replace("%", "") === productName
      );

      if (product?.length > 0) {
        console.log("product: ", product);
        setSelectedProduct(product);
      } else {
        window.location.assign("/");
      }
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Row
        className={
          quickViewModal
            ? `product_page_container quick_view`
            : `product_page_container`
        }
        style={{
          height: quickViewModal ? windowSize.height - 150 : "auto",
        }}
      >
        {selectedProduct &&
          selectedProduct?.map((item, i) => {
            return (
              <Col key={item.name} xs="12" md={12}>
                <Row>
                  <Col md={6}>
                    <img
                      width="100%"
                      src={`/${item?.images[imageIndex]}`}
                      alt="Product"
                      style={{
                        cursor: "zoom-in",
                      }}
                      onClick={() => {
                        toggleProductZoom();
                      }}
                    />
                    <Row>
                      {item?.images.map((image, i) => {
                        return (
                          <div key={image} className="pructpage_thumbnail">
                            <img
                              onClick={() => setImageIndex(i)}
                              className="pructpage_thumbnail_img"
                              src={`/${image}`}
                              alt="Product"
                            />
                          </div>
                        );
                      })}
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className="product_details">
                      <Col>
                        <h1 className="product_details_heading">
                          {item?.name}
                        </h1>
                        <Row className="prodct_revw_wrapper">
                          <span>
                            <Star />
                            <Star />
                            <Star />
                            <span className="ml-3">100 reviewes</span>
                          </span>
                        </Row>
                        <p className="product_small_descp">
                          {item?.Description[0].byline}
                        </p>
                        <p className="product_fullll_descp">
                          {item?.Description[0].full_info}
                        </p>
                        <p className="product_small_info">
                          {item?.Description[0].quality}
                        </p>
                        <Row className="product_price_pdct_page">
                          <p>{item?.mrp}</p>{" "}
                          <p className="price_mrp">{item.offerPrice}</p>
                        </Row>

                        <p className="prdctdetls_quantity">Quantity</p>
                        <Row className="quntity_wrapper_prdct">
                          <Col className="qntyty_box" sm={4} md={4}>
                            <Minus
                              className="cursor-pointer"
                              width={"18px"}
                              onClick={() => {
                                if (quantity > 1) {
                                  setQuantity(quantity - 1);
                                }
                              }}
                            />
                          </Col>
                          <Col className="qntyty_box text-center" sm={4} md={4}>
                            {quantity}
                          </Col>
                          <Col className="qntyty_box" sm={4} md={4}>
                            <Plus
                              className="cursor-pointer"
                              width={"18px"}
                              onClick={() => {
                                setQuantity(quantity + 1);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <button
                            className="addcart_prdct_page"
                            onClick={() => {
                              handleAddToCart(
                                item?.name,
                                item?.offerPrice,
                                quantity,
                                item?.images[0],
                                item?.id
                              );
                            }}
                          >
                            Add to cart
                          </button>
                        </Row>

                        <Row>
                          <button className="buynow_prdct_page">
                            Buy it now
                          </button>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Modal
                  isOpen={isOpenZoomProduct}
                  toggle={toggleProductZoom}
                  fullscreen={true}
                  centered={true}
                >
                  <ZoomProduct
                    currentSrc={item?.images[imageIndex]}
                    images={item?.images}
                  />
                </Modal>
              </Col>
            );
          })}
      </Row>
    </>
  );
}

export default ProductPage;
